<div *ngIf="notification" class="notificationDetails">
  <div class="notificationDetails-header p-t-xs">
    <h3>
      {{ notification.notificationHeader }}
      <span *ngIf="notification?.wasProcessed"
            [ngClass]="notification.sanitizedData.processedClass"
            class="tag">
        {{ notification.sanitizedData.replyTranslation }}
      </span>
    </h3>
    <div *ngIf="notification.sanitizedData?.isFallbackRecipient" class="default-recipient text-xs"
         tooltip="{{'INBOX.default_recipient'|translate}}">
      <em class="fa fa-light fa-user-check"></em>
    </div>
  </div>
  <div class="notificationDetails-body">
    <div class="pull-left m-l-sm">
      <em class="{{notification.sanitizedData?.icon}} p-a-sm"></em>
    </div>
    <div class="m-l-lg">
      <div class="notification-type">
        <div>{{('NOTIFICATIONS.' + notification.notificationType) | translate}}</div>
        <div class="text-muted small">{{ notification.effectiveDate | gpDate:{withTime: true}: (trigger$|async) }}</div>
        <div *ngIf="notification.dueDate" class="due-date-label pull-right">
          {{ notification.dueDate | gpDate:{timeLeft: true}: (trigger$|async) }}
        </div>
      </div>
    </div>
    <div class="p-a" (click)="onNotificationBodyClick($event)"
         [innerHTML]="notification.sanitizedData?.notificationDescription | bypassSecurityTrustHtml"
         [attr.test-id]="'notification-body-click'">
    </div>
    <ng-container *ngIf="!isSent && !sending && !notification.wasProcessed">
      <div class="row p-b-0" *ngIf="buttons.length">
        <div class="col-12">
          <small class="text-muted">{{ 'NOTIFICATIONS.comment' | translate }}</small>
          <div class="_500">
          <textarea class="textarea-control"
                    [(ngModel)]="comment"
                    [rows]="3">
          </textarea>
          </div>
        </div>
      </div>

      <div class="row p-t-0" *ngIf="buttons.length">
        <div class="col-12">
          <button class="btn blue pull-right m-l" *ngFor="let btn of buttons"
                  (click)="sendAnswer(btn)">
            {{notificationsService.getButtonTranslation(btn)}}
          </button>
        </div>
      </div>
    </ng-container>
    <div class="padding text-center" *ngIf="sending">
      <em class="fa fa-light fa-spinner fa-spin"></em>
    </div>

  </div>
</div>

<gp-modal size="lg" gp-modal="team-planning" [closable]="true" [form]="false" #teamsModal (closed)="onModalClosed()">
  <div class="gp-modal-title">
    {{ 'MENU.MSS.team_planning' | translate }}
  </div>
  <div class="gp-modal-body teams-table">
    <team-planning *ngIf="selectedTeam"
                   [isIframe]="true"
                   [currentDate]="selectedTeam.currentDate"
                   [selectedTeam]="selectedTeam.id">
    </team-planning>
  </div>
  <div class="gp-modal-footer"></div>
</gp-modal>
